<template>
  <div id="bg-image">
    <register-page />
  </div>
</template>

<script>
import RegisterPage from '../process/Register/RegisterPage.vue';
  export default {
      name: 'LoginPage',
      components: {
        RegisterPage,
      },
  };
</script>

<style scoped>

</style>
